import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import "./myreviewrating.css";
import ReviewImg from "../../assets/images/cat-8.png";
import ErrorImg from "../../assets/images/no_review.jpeg";
import StarIcon from "@mui/icons-material/Star";
import { Link } from "react-router-dom";
import { baseURL } from "../../constants/url";
import uploadIcon from "../../assets/images/add-image.png";

const MyReviewRating = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [rating, setRating] = useState(0);
  const [description, setDescription] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [orderProducts, setOrderProducts] = useState([]);
  const [selectedProductName, setSelectedProductName] = useState("");
  const [selectedProductId, setSelectedProductId] = useState(null);

  const userId = parseInt(localStorage.getItem("user_id") || "0");
  const token = localStorage.getItem("authToken");
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const res = await fetch(`${baseURL}common/ratings/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        const userReviews = data.filter(
          (review) =>
            review.user_first_name === user.first_name &&
            review.user_last_name === user.last_name
        );
        setReviews(userReviews);
        console.log("User:", user);
        console.log("Fetched Reviews:", data);
        console.log("Filtered User Reviews:", userReviews);
        console.log("review print", userReviews)

      } catch (err) {
        console.error("Review fetch error:", err);
      }
    };

    const fetchOrders = async () => {
      try {
        const res = await fetch(`${baseURL}common/orders_history/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();

        const reviewedIds = new Set(reviews.map((r) => r.variant_id));
        const allItems = data.flatMap((order) =>
          order.items
            .filter((item) => !reviewedIds.has(item.variant))
            .map((item) => ({
              id: item.variant,
              name: item.product_name,
              image: item.product_image,
            }))
        );

        setOrderProducts(allItems);
      } catch (err) {
        console.error("Order fetch error:", err);
      }
    };

    if (token && userId) {
      fetchReviews();
      fetchOrders();
    }
  }, [token, userId]);

  const handleStarClick = (index) => setRating(index + 1);

  const handleReviewClick = (productName, productId) => {
    setSelectedProductName(productName);
    setSelectedProductId(productId);
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setRating(0);
    setDescription("");
    setSelectedImage(null);
  };

   
       const handleSubmit = async () => {
      
                console.log("form data value print",{
                  token,
                  userId,
                  selectedProductId,
                  rating,
                  description,
                  selectedImage
              });
      
            if (!token || !userId || !selectedProductId || rating === 0 || !description) {
            return Swal.fire({
              icon: "error",
              title: "Missing Data",
              text: "Please fill in all fields before submitting.jk",
            });
          }
      
          const formData = new FormData();
          formData.append("variant", selectedProductId);
          formData.append("user", userId);
          formData.append("rating", rating);
          formData.append("review", description);
          if (selectedImage) {
            formData.append("images", selectedImage);
          }
      
          try {
            const res = await fetch(`${baseURL}common/ratings/`, {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
              },
              body: formData,
            });
      
            const data = await res.json();
            if (!res.ok) {
              throw new Error(data.detail || "You’ve already reviewed this product.");
            }
      
            Swal.fire({
              icon: "success",
              title: "Success!",
              text: "Review submitted successfully.",
            });
      
            closePopup();
          } catch (err) {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: err.message || "Failed to submit review.",
            });
          }
        };


  const popupStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  };

   const modalContentStyle = {
  //   background: "#fff",
  //   padding: "2rem",
  //   borderRadius: "8px",
  //   textAlign: "center",
  //   minWidth: "600px",
   };

  return (
    // <div className="container-fluid">
    //   <div className="container">
    //     <div className="row">
    //       <div className="col-lg-12">
            <div className="height80vh_old">
              <div className="card_common">
                <div className="heading_common">
                  <h3>My Reviews ({reviews.length})</h3>
                </div>
                {reviews.length === 0 ? (
                  <div className="text-center">
                    <img src={ErrorImg} alt="No reviews" className="img-fluid" />
                  </div>
                ) : (
                  <div className="review_rating">
                    {reviews.map((review) => (
                      <div key={review.id} className="review_rating_grid d_flex gap_20 pb_10 pt_10 border_bottom">
                        <div className="reviewImg">
                          <img  src={review.images?.[0]?.image || ReviewImg}
                            alt="Review"
                            onError={(e) => (e.target.src = ReviewImg)}
                          />
                        </div>
                        <div>
                          <p className="color_grayDark">
                            {review.product_name || "Product Title"}
                          </p>
                          <div className="d_flex gap_10 pt_5 align_center">
                            <p className="font_13">
                              <span className="rating_box">
                                {review.rating}.0 <StarIcon />
                              </span>
                            </p>
                            <p className="font_13">{review.review}</p>
                          </div>
                          <div className="d_flex gap_10 align_center font_12 pt_5">
                            <p>
                              {review.user_first_name} {review.user_last_name}
                            </p>
                            <p className="color_green">
                              {new Date(review.created_at).toLocaleDateString("en-IN", {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                              })}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="card_common mt_15">
                <div className="heading_common  ">
                  <h3>Orders You Might Want to Review</h3>
                </div>
                <div className="review_rating">
                 {orderProducts.map((product, idx) => (
                    <div key={idx} className="review_rating_grid d_flex gap_20 pb_15 pt_15">
                      <div className="reviewImg">
                        <img
                          src={product.image || ReviewImg}
                          alt="Product"
                          onError={(e) => (e.target.src = ReviewImg)}
                        />
                      </div>
                      <div>
                        <p className="color_grayDark">{product.name}</p>
                        <div className="d_flex gap_10 align_center mt_10">
                          {[...Array(5)].map((_, index) => (
                            <StarIcon
                              key={index}
                              onClick={() => handleStarClick(index)}
                              style={{
                                color: index < rating ? "#ffc107" : "#ccc",
                                cursor: "pointer",
                              }}
                            />
                          ))}
                        </div>
                        <div className="d_flex gap_10 align__center mt_10">
                          <Link to="#" onClick={() => handleReviewClick(product.name, product.id)}>
                            Rate and Review
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))}


                  {showPopup && (
                    <div style={popupStyle}>
                      <div style={modalContentStyle} className="modalStyle">
                        <h6 className="text_left">Rate: {selectedProductName}</h6>
                        <div className="text_left mb_10">
                          {[...Array(5)].map((_, index) => (
                            <StarIcon
                              key={index}
                              onClick={() => handleStarClick(index)}
                              style={{
                                color: index < rating ? "#ffc107" : "#ccc",
                                cursor: "pointer",
                              }}
                            />
                          ))}
                        </div>
                        <div className="form-group text_left">
                          <label className="required">Review</label>
                          <textarea
                            rows="5"
                            placeholder="Write your review here..."
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                          ></textarea>
                        </div>
                        <div className="pb_15 pt_15s">
                          <label className="upload-box">
                            <span className="upload-placeholder">
                              <img
                                src={uploadIcon}
                                width="30"
                                alt="upload"
                              />
                            </span>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => setSelectedImage(e.target.files[0])}
                            />
                          </label>
                        </div>
                        <div className="d_flex justify_sp_between align__center mt_15">
                          <button className="saveForm" onClick={handleSubmit}>
                            Save
                          </button>
                          <button className="cross_btn" onClick={closePopup}>
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {/* End Order Section */}
            </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default MyReviewRating;